module.exports = __webpack_public_path__ + "static/media/Products (1).77556ac2.png";